import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetPunchoutIdentityApiParameter } from "@TKCCP/Services/PunchoutIdentityService";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import { createContext } from "react";

export function getIdentityDataView(state: ApplicationStateTKCCP, getOrdersParameter: GetPunchoutIdentityApiParameter) {
    return getDataView(state.dataPunchoutIdentity1, getOrdersParameter);
}

export const IdentityDataViewContext = createContext<ReturnType<typeof getIdentityDataView>>({
    value: undefined,
    isLoading: false,
});
